import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'
//import * as VueGoogleMaps from 'vue2-google-maps'
import VueMapbox from 'vue-mapbox';
import Mapbox from 'mapbox-gl';

Vue.use(VueMapbox, {mapboxgl: Mapbox });

Vue.config.productionTip = false

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBMUwUblOd-XDtR1-55FDlNDD-5dgZhenw',
//     libraries: 'places'
//   }
// });

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
